import React, { useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FEATURE_FLAGS } from '../../config/featureFlagKeys';
import { setCloudRunApiEnabled } from '../../services/api';

/** Sends API requests to Cloud Run while the useCloudRunUrl flag is on. Renders nothing. */
const ApiBaseUrlSync: React.FC = () => {
    const isCloudRunEnabled = !!useFlags()[FEATURE_FLAGS.USE_CLOUD_RUN_URL];

    useEffect(() => {
        setCloudRunApiEnabled(isCloudRunEnabled);
    }, [isCloudRunEnabled]);

    return null;
};

export default ApiBaseUrlSync;
